import { ITimePeriod, ITimePeriodRequest, IUrlFilterItem } from '@lla-platform/core/core-data-access'

export interface ISalariesSummaryRequest extends ITimePeriodRequest {
  locationIds?: string[]
}

// Period value with status flags
export interface ISalariesPeriodValue {
  amount: number
  isNewBusiness: boolean
  isPartialSelection: boolean
  hasMissingPayments: boolean
}

// Period object in periods array
export interface ISalariesPeriod {
  name: string
  startDate: string
  endDate: string
  isPartialSelection: boolean
}

// NEW API Response structure
export interface ISalariesSummaryResponse {
  timePeriod: ITimePeriod
  periods: ISalariesPeriod[] // [{ name: "Jan 2025", fullMonth: true }, ...]
  globalTotals: ISalariesGlobalTotals
  locations: ISalariesLocationItem[]
}

export interface ISalariesGlobalTotals {
  [period: string]: ISalariesPeriodValue // Dynamic period keys with amount and fullMonth
  total: ISalariesPeriodValue
  monthlyAvg: ISalariesPeriodValue
}

export interface ISalariesLocationItem {
  locationId: string
  locationName: string
  values: ISalariesLocationValues
}

export interface ISalariesLocationValues {
  [period: string]: ISalariesPeriodValue // Dynamic period keys with amount and fullMonth
  total: ISalariesPeriodValue
  monthlyAvg: ISalariesPeriodValue
}

// Transformed data structures for the component
export interface ISalariesSummaryTransformed {
  periods: ISalariesPeriod[]
  locations: ISalariesLocationRow[]
  grandTotalRow: ISalariesLocationRow
  timePeriod?: ITimePeriod
}

// Cell data with heat map coloring support
export interface ISalariesCellData {
  value: number
  isNewBusiness: boolean
  isPartialSelection: boolean
  hasMissingPayments: boolean
  backgroundColor?: string
  filterParams?: IUrlFilterItem
}

export function isCompleteCell(cell: ISalariesCellData): boolean {
  return !cell.isNewBusiness && !cell.isPartialSelection && !cell.hasMissingPayments
}

export interface ISalariesLocationRow {
  locationId: string
  locationName: string
  locationFilterParams?: IUrlFilterItem
  [period: string]: string | number | ISalariesCellData | IUrlFilterItem | undefined
}
